/*首页功能相关路由*/
const khfb_cockpit = () =>  import("../../../studio/new_cockpit_box/cockpit_children/khfb_cockpit/khfbCockpitBoxMain");

export default [
  {
    path: '/khfb_cockpit',
    name: '客户驾驶舱',
    component: khfb_cockpit
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/khfb/khfb_cockpit_page.js